import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import Bundle from '@saucelabs/sl-component-bundle';
import {
  InExperimentTernaryContainer,
  InExperimentRoute,
} from '@saucelabs/sl-container-experiment';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import analyticsReducer from './reducers';

const importFailureAnalysis = () => import(/* webpackChunkName: "an-failure-analysis" */ './containers/FailureAnalysisContainer');
const importFlatConcurrency = () => import(/* webpackChunkName: "an-flat-concurrency" */ './containers/FlatVmConcurrencyContainer');
const importFlatTrends = () => import(/* webpackChunkName: "an-flat-trends" */ './containers/FlatTrendsContainer');
const importTestHistory = () => import(/* webpackChunkName: "an-test-history" */ './containers/TestHistoryContainer');
const importTestOverview = () => import(/* webpackChunkName: "an-test-overview" */ './containers/TestOverviewContainer');
const importTestError = () => import(/* webpackChunkName: "an-test-overview" */ './containers/TestErrorContainer');

const importTestHistoryExperiment = () => import(/* webpackChunkName: "an-test-history-v2" */ './containers/v2/TestHistoryContainer');

const AnalyticsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.PERFORMANCE}>
      <Switch>
        <Route
          path={`${match.url}/test-history`}
          render={(props) => (
            <InExperimentTernaryContainer name="web-ui-aggregated-test-history">
              <Bundle load={importTestHistoryExperiment}>
                {(Component) => (
                  <Component
                    activeTab={match.url}
                    {...props}
                  />
                )}
              </Bundle>
              <Bundle load={importTestHistory}>
                {(Component) => (
                  <Component
                    activeTab={match.url}
                    {...props}
                  />
                )}
              </Bundle>
            </InExperimentTernaryContainer>
          )}
        />
        <Route
          path={`${match.url}/test-patterns/:tabName?/:rootCauseId?`}
          render={(props) => (
            <Bundle load={importFailureAnalysis}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          )}
        />
        <Route
          path={`${match.url}/test-overview/:tabName?/:status?`}
          render={(props) => (
            <Bundle load={importTestOverview}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          )}
        />
        <BundleRoute
          load={importFlatConcurrency}
          path={`${match.url}/trends/concurrency`}
        />
        <BundleRoute
          load={importFlatTrends}
          path={`${match.url}/trends`}
        />
        <InExperimentRoute experiment="web-ui-insights-error-menu">
          <BundleRoute
            load={importTestError}
            path={`${match.url}/test-errors`}
          />
        </InExperimentRoute>
      </Switch>
    </SentryBoundary>
  </LoginRequiredContainer>
);

AnalyticsRoutes.propTypes = {
  location: PropTypes.any.isRequired,
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.analytics', attachReducer(analyticsReducer),
)(AnalyticsRoutes);
